import Api from "../config/Axios";

const toQueryValue = (value) => {
  if (Array.isArray(value)) {
    return value.filter((item) => item !== undefined && item !== null && item !== "").join(",");
  }
  if (value === undefined || value === null) return "";
  return String(value);
};

// Break List
export const getBreakList = (token, user_id, data = {}) => {
  const config = {
    headers: {
      Authorization:
      "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  const params = new URLSearchParams();
  params.set("status", "break");
  params.set("page", data.currentPage !== "" && data.currentPage != null ? data.currentPage : 1);
  params.set("limit", data.limit !== "" && data.limit != null ? data.limit : 10);

  const zones = toQueryValue(data.zones);
  if (zones) {
    params.set("zones", zones);
  }

  const keyword = toQueryValue(data.keysearch || data.keyword);
  if (keyword) {
    params.set("keyword", keyword);
  }

  const riderId = toQueryValue(data.riderId || data.id);
  if (riderId) {
    params.set("id", riderId);
  }

  const reasons = toQueryValue(data.reasons);
  if (reasons) {
    params.set("reasons", reasons);
  }

  return Api.get(`api/web/rider/list?${params.toString()}`, config);
};

// Break Apply or Break remove
export const getBreakMark = (token, user_id, data) => {
  const config = {
    headers: {
      Authorization:
      "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.patch(`api/web/rider/mark-status/${data.type}/${data.riderId}`,data, config)
}
